import printerInstance from '../instance'

const openPrintersCashDesk = (desktopClientUsername) => {
  return printerInstance.post('/printers/openCashDesk', { desktopClientUsername })
}

export default openPrintersCashDesk
